import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { IncomeDTO } from '@shared/types';

interface Paginated<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
}

export interface IncomeFilters {
  month?: string;
  from?: string;
  to?: string;
  categoryId?: number;
  isRecurring?: boolean;
  page?: number;
}

export function useIncomes(filters: IncomeFilters = {}) {
  return useQuery({
    queryKey: ['incomes', filters],
    queryFn: async () => (await api.get<Paginated<IncomeDTO>>('/incomes', { params: filters })).data,
  });
}

export interface CreateIncomeInput {
  categoryId?: number | null;
  amount: number;
  description: string;
  receivedAt: string;
}

export function useCreateIncome() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: CreateIncomeInput) => (await api.post<IncomeDTO>('/incomes', input)).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incomes'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useDeleteIncome() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => api.delete(`/incomes/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incomes'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
